import { data } from '../../svg/ConditionGraph/data';
import { makeIcon } from '../makeIcon';

export const ConditionGraph = makeIcon(data, 'condition_graph', 'ConditionGraph');

export default ConditionGraph;
